import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { FormFieldModel, GenericFormService } from "@cv-invision/cv.invision-views.ux";
import { FORM_VALUE_OPTION } from "../../select-chips/model/config-type.model";

@Component({
	selector: 'cv-create-edit-field-value',
	templateUrl: './create-edit-field-value.component.html',
	styleUrls: [ './create-edit-field-value.component.scss' ]
})
export class CreateEditFieldValueComponent implements OnInit, OnDestroy {
	@Input() data;
	formBuilderConfig: any = FORM_VALUE_OPTION;
	showFormFields = false;
	private atComponentDestroy = new Subject();
	modelData: any = {};
	valueDate: any;
	isDate = false;
	formFields = [];

	constructor(
		public dynamicDialogRef: DynamicDialogRef,
		private genericFormService: GenericFormService,
		private dynamicDialogConfig: DynamicDialogConfig
	) {
		this.modelData['label'] = '';

		if (this.dynamicDialogConfig.data) {
			const data = this.dynamicDialogConfig.data;

			if(data.childForm) {
				for (const key in data.childForm) {
					this.modelData[key] = data[key];
				}
				this.formBuilderConfig = data.childForm;
			}


			this.isDate = data.isDate;
		}
	}

	ngOnInit(): void {
		this.genericFormService.setFormFieldList(this.formBuilderConfig);

		this.genericFormService.initForm(this.modelData);

		const formBuilderConfig = this.formBuilderConfig;
		this.formFields = [];
		if(this.formBuilderConfig){
			for (const key in formBuilderConfig) {
				const field: FormFieldModel = {
					simpleField: formBuilderConfig[key].DataType !== 'Array',
					key: key,
					label: formBuilderConfig[key].DisplayText,
					hidden: 'hidden' in formBuilderConfig[key] ? formBuilderConfig[key].hidden : false,
					customClass: formBuilderConfig[key].CustomClass,
				}
				this.formFields.push(field);
			}
		}

		this.genericFormService.formObserver.subscribe((data) => {
			this.showFormFields = true;
		})
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

	/**
	 * event to close modal
	 */
	close(): void {
		this.dynamicDialogRef.close();
	}

	/**
	 * event to close the modal and pass the information to the parent modal
	 */
	addNewItem(): void {
		if (this.genericFormService.form.valid) {
			this.dynamicDialogRef.close({data: this.genericFormService.form.value});
		}
	}

}
